<template>
    <div class="rich-text">
        <div class="rich-text-cover"
             ref="cover">
            <div v-for="(item, index) in data"
                 class="rich-text-item"
                 :class="{'rich-text-item_cur': item.type !== 'pendding'}"
                 :key="index">

                <!-- 文本 -->
                <div class="rich-text-item_text"
                     v-if="item.type === 'text'">
                    <auto-textarea v-model="item.value" />
                </div>

                <!-- 边框 -->
                <div class="rich-text-item_border"
                     v-if="item.type === 'border'"></div>

                <!-- image -->
                <template v-if="item.type === 'image'">
                    <img :src="item.value">
                    <a-spin :spinning="index + 1 === data.length && loading" class="rich-text-item_loading"/>
                </template>

                <a-popover trigger="click"
                           v-if="item.type === 'pendding'"
                           placement="right"
                           overlayClassName="rich-text-popover"
                           @visibleChange="visibleChange"
                           v-model="visible">
                    <template slot="content">
                        <div class="rich-text-popover-cover">
                            <div class="rich-text-popover-title">
                                <span>添加模块</span>
                                <a-icon @click="close"
                                        class="point"
                                        type="close"
                                        style="font-size: 12px;" />
                            </div>

                            <div class="rich-text-popover-cont">
                                <div class="rich-text-popover-cont-item"
                                     @click="addText">
                                    <i class="icon-text"></i>
                                </div>
                                <div class="rich-text-popover-cont-item" v-if="showImg"
                                     @click.stop="addImage">
                                    <i class="icon-image"></i>
                                </div>
                                <div class="rich-text-popover-cont-item"
                                     @click="addBorder">
                                    <i class="icon-line"></i>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="rich-text-item_pendding"></div>
                </a-popover>

                <div class="rich-text-tool"
                     v-if="item.type !== 'pendding'">
                    <div class="rich-text-tool-item"
                         @click="addDown(index, $event)">
                        <a-icon type="plus-circle"
                                style="font-size: 16px;" />
                    </div>
                    <div class="rich-text-tool-item"
                         @click="up(index)"
                         v-if="index">
                        <a-icon type="to-top"
                                style="font-size: 16px;" />
                    </div>
                    <div class="rich-text-tool-item"
                         @click="down(index)"
                         v-if="index < (data.length -1)">
                        <a-icon type="to-top"
                                style="font-size: 16px; transform:rotate(180deg);" />
                    </div>
                    <div class="rich-text-tool-item"
                         @click="del(index)">
                        <a-icon type="delete"
                                style="font-size: 16px;" />
                    </div>
                </div>
            </div>
        </div>
        <image-uploader hidden
                        ref="uploader"
                        @beforeUpload="beforeUpload"
                        @uploaded="uploaded"
                        @imageUploaded="imageUploaded"></image-uploader>

        <div class="rich-text-btn point"
             @click="add">
            <i class="icon icon-plus mr8"
               style="font-size: 20px;color: rgba(245, 127, 37, 1);" />
            添加模块
        </div>
    </div>
</template>

<script type="text/javascript">
/**
 * 简易的富文本编辑器
 * @author leon
 *
 * @prop list {Array} 编辑器数据
 *
 * @func getData 给父组件提供获取当前编辑器数据 this.$refs.child.getData
 */

// list 字段说明
// let list = [
//         // type = 'text' 表示文本
//         // type = 'image' 表示图片
//         // type = 'border' 表示边框
//         {
//             type: 'text',
//             value: '',  // 对应类型的值
//             link: ''    //图片对应的url （暂时没这个需求）
//         }
//     ]

import autoTextarea from "./auto-textarea.component";
import ImageUploader from "@/components/common/image-uploader.component";

export default {
    name: "richtext",
    components: {
        autoTextarea,
        ImageUploader
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        showImg: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: this.$utils.deepClone(this.list),
            pendding: {
                type: "pendding",
                value: ""
            },
            visible: false,
            uploadIndex: 0,
            loading: false
        };
    },
    computed: {},
    watch: {
        list(val) {
            this.data = this.$utils.deepClone(val);
        }
    },
    methods: {
        beforeUpload () {
            this.loading = true;
            this.data.forEach((item, index) => {
                if (item.type === "pendding") {
                    this.uploadIndex = index;
                    this.data.splice(index, 1, {
                        type: "image",
                        value: ''
                    });
                }
            });
        },
        uploaded () {
            this.uploadIndex = 0;
        },
        imageUploaded () {
            this.loading = false;
        },
        // 添加 pendding 状态
        add() {
            this.visible = true;
            this.data.push(this.pendding);

            this.$nextTick(() => {
                let cover = this.$refs.cover;
                cover.scrollTop = cover.scrollHeight;
            });
        },

        // 添加text模块
        addText() {
            this.data.forEach((item, index) => {
                if (item.type === "pendding") {
                    this.data.splice(index, 1, {
                        type: "text",
                        value: ""
                    });
                }
            });
        },

        // 添加image模块
        addImage() {
            this.$refs.uploader.invokeUpload((path, file, res) => {
                this.loading = false;
                this.data.forEach((item, index) => {
                    if(index === this.uploadIndex) {
                        item.value = path;
                    }
                });
            });
        },

        // 添加border模块
        addBorder() {
            this.data.forEach((item, index) => {
                if (item.type === "pendding") {
                    this.data.splice(index, 1, {
                        type: "border",
                        value: ""
                    });
                }
            });
        },

        // 向下添加
        addDown(index, e) {
            this.visible = true;
            this.data.splice(index + 1, 0, this.pendding);
            let cover = this.$refs.cover;
            this.$nextTick(() => {
                let path = e.path;
                let el = path.find(
                    el => el.className === "rich-text-item rich-text-item_cur"
                );
                let offsetTop = el.offsetTop;

                // 剩余空间不够定位
                if (offsetTop + (128 + 24) * 2 > cover.clientHeight) {
                    cover.scrollTop = cover.scrollTop + 128 + 24;
                }
            });
        },

        // 上移
        up(index) {
            this.data = this.swapArr(this.data, index, index - 1);
        },

        // 下移
        down(index) {
            this.data = this.swapArr(this.data, index, index + 1);
        },

        // 删除
        del(index) {
            let the = this;
            this.$confirm({
                content: "是否删除该模块？",
                onOk() {
                    the.data.splice(index, 1);
                }
            });
        },

        // popover 关闭时删除 pendding 状态
        visibleChange(val) {
            this.data.forEach((item, index) => {
                if (item.type === "pendding") {
                    this.data.splice(index, 1);
                }
            });
        },

        close() {
            this.visible = false;
            this.visibleChange(false);
        },
        /**
         * 位置互换
         *
         * @param arr {array} 操作的原数组
         * @param index1 {number} 交换的索引1
         * @param index2 {number} 交换的索引2
         *
         * @return arr {array} 互换后的新数组
         */
        swapArr(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            return arr;
        },

        // 提供给父组件获取
        getData() {
            this.data.forEach((el, index) => {
                // level 后台需要的字段
                el.level = index + 1;
            });
            return this.data;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="scss">
.rich-text {
    width: 436px;
    border-radius: 4px;
    border: 1px solid rgba(226, 226, 226, 1);

    &-cover {
        height: 596px;
        overflow-x: hidden;
        overflow-y: scroll;
        background: #fff;
        padding: 16px;
    }

    &-btn {
        background: rgba(245, 245, 245, 1);
        height: 56px;
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        @include pxAndLh(14);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &-tool {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 36px;
        display: none;
        padding-right: 16px;

        &-item {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.65);
            border-radius: 4px 4px 0px 0px;
            margin-left: 8px;
            cursor: pointer;

            i {
                color: #fff;
            }
        }
    }

    &-item {
        margin-top: 24px;
        position: relative;

        &_cur {
            &:hover {
                box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.2);
                border-radius: 4px;

                .rich-text-tool {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }

        &_loading {
            display: flex !important;
            align-items: center;
            justify-content: center;
            min-height: 128px;
            width: 100%;
            border-radius: 4px;
            border: 1px solid rgba(226, 226, 226, 1);
        }

        &:first-of-type {
            margin-top: 0;
        }

        img {
            width: 100%;
            display: block;
            border-radius: 4px;
        }

        &_pendding {
            border: 1px dashed rgba(0, 0, 0, 0.15);
            height: 128px;
            border-radius: 4px;
        }

        &_text {
            padding: 16px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            min-height: 128px;
        }

        &_border {
            padding: 16px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.15);

            &:before {
                content: "";
                display: block;
                width: 100%;
                border-top: 2px dashed rgba(0, 0, 0, 0.3);
            }
        }
    }
}

// popover 显示位置
.rich-text-popover {
    &-cover {
        width: 280px;
        padding: 0 8px;
    }

    &-title {
        display: flex;
        justify-content: space-between;
        @include pxAndLh(16);
        color: $text-color-black-85;
    }

    &-cont {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;

        &-item {
            width: 72px;
            height: 72px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .icon-text {
                display: block;
                width: 72px;
                height: 72px;
                background: url("../../assets/image/icon-word.png");
            }

            .icon-image {
                display: block;
                width: 72px;
                height: 72px;
                background: url("../../assets/image/icon-picture.png");
            }

            .icon-line {
                display: block;
                width: 72px;
                height: 72px;
                background: url("../../assets/image/icon-line.png");
            }
        }
    }

    .ant-popover-inner {
        background: rgba(245, 245, 245, 1);
    }

    .ant-popover-content {
        margin-left: 56px;
    }

    .ant-popover-content > .ant-popover-arrow {
        margin-left: 56px;
    }
}
</style>